<template>
  <div>
    <div class="home-dropdowns">
      <div class="container-fluid dd-wrap">
        <div class="container">
          <div class="blob"></div>
          <div class="faq-items">
            <div class="faq-item active-faq-item" v-on:click='faqActive'>
              <div class="faq-header">
                <div class="faq-name">
                  <div class="faq-icon">
                    <svg width="23" height="21" viewBox="0 0 23 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path fill-rule="evenodd" clip-rule="evenodd" d="M10.8052 0.402808C11.1131 -0.130526 11.8829 -0.130526 12.1908 0.402808L22.8876 18.9302C23.1955 19.4635 22.8106 20.1302 22.1948 20.1302H0.801193C0.185353 20.1302 -0.199547 19.4635 0.108373 18.9302L10.8052 0.402808ZM9.88833 14.2276H13.1079V17.4472H9.88833V14.2276ZM13.6439 6.71519H9.35113L9.88773 13.1544H13.1073L13.6439 6.71519Z" fill="#FCAF05"/>
                    </svg>
                  </div>
                  <h2>Set Expiry Alerts</h2>
                </div>
                <svg width="18" height="15" viewBox="0 0 18 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M9 15L17.6603 0H0.339746L9 15Z" fill="#676868"/>
                </svg>
              </div>
              <div class="faq-answer">
                <p>Use our 2-Click Expiry Alerts to make sure you never miss a renewal. While the default Alert timing is provided on Asia Actual recommendations, you can set reminders specific to your needs.</p>
              </div>
            </div>
            <div class="faq-item" v-on:click='faqActive'>
              <div class="faq-header">
                <div class="faq-name">
                  <div class="faq-icon">
                    <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path fill-rule="evenodd" clip-rule="evenodd" d="M11.5 23C17.8513 23 23 17.8513 23 11.5C23 5.14868 17.8513 0 11.5 0C5.14871 0 0 5.14868 0 11.5C0 17.8513 5.14871 23 11.5 23ZM17.4395 5.93933L9.50012 13.8787L6.06076 10.4393L3.93945 12.5607L9.50012 18.1213L19.5608 8.06067L17.4395 5.93933Z" fill="#FCAF05"/>
                    </svg>
                  </div>
                  <h2>Research Classification</h2>
                </div>
                <svg width="18" height="15" viewBox="0 0 18 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M9 15L17.6603 0H0.339746L9 15Z" fill="#676868"/>
                </svg>
              </div>
              <div class="faq-answer">
                <p>Type in the Product Code or Competitor Product name and a country to research how your product will be classified in a new market. Classification confirmation provided by Asia Actual if needed.</p>
              </div>
            </div>
            <div class="faq-item" v-on:click='faqActive'>
              <div class="faq-header">
                <div class="faq-name">
                  <div class="faq-icon">
                    <svg width="28" height="17" viewBox="0 0 28 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M14 0C8.6503 0 3.79892 2.92687 0.219086 7.68088C-0.0730285 8.07037 -0.0730285 8.6145 0.219086 9.00399C3.79892 13.7637 8.6503 16.6906 14 16.6906C19.3497 16.6906 24.2011 13.7637 27.7809 9.00972C28.073 8.62023 28.073 8.0761 27.7809 7.68661C24.2011 2.92687 19.3497 0 14 0ZM14.3838 14.2219C10.8326 14.4453 7.89997 11.5185 8.12335 7.96154C8.30664 5.02895 10.6836 2.65194 13.6162 2.46865C17.1674 2.24527 20.1 5.17214 19.8766 8.72906C19.6876 11.6559 17.3106 14.0329 14.3838 14.2219ZM14.2062 11.507C12.2931 11.6273 10.7123 10.0522 10.8383 8.1391C10.9357 6.55825 12.2187 5.28097 13.7995 5.17787C15.7126 5.05758 17.2934 6.63271 17.1674 8.54577C17.0643 10.1324 15.7813 11.4096 14.2062 11.507Z" fill="#FCAF05"/>
                    </svg>
                  </div>
                  <h2>Identify Predicates</h2>
                </div>
                <svg width="18" height="15" viewBox="0 0 18 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M9 15L17.6603 0H0.339746L9 15Z" fill="#676868"/>
                </svg>
              </div>
              <div class="faq-answer">
                <p>Use our proprietary search to identify predicate devices based on US Product Code, competitors’ parent company, or keywords.</p>
              </div>
            </div>
          </div>
          <div class="faq-img-frame">
            <img src="@/assets/images/home/faq-item_1.png" alt="Set Expiry Alerts" class="img-fluid"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  methods:  {
    faqActive(e) {
      let target = e.target.closest('.faq-item');
      let faqItems = document.querySelectorAll('.faq-item');
      
      for(let item of faqItems) {
        item.classList.remove('active-faq-item');
      }

      target.classList.add('active-faq-item');
    }
  }
}


</script>

<style lang="scss">
  .home-dropdowns {
    padding-top: 350px;

    .dd-wrap {
      position: relative;

      .container {
        display: flex;
        justify-content: space-between;
        align-items: center;
        max-width: 1320px;

        .blob {
          position: absolute;
          right: 0;
          top: -15%;
          height: 120%;
          width: 45%;
          background: #f8f8f8;
          z-index: -1;
          border-radius: 25px 0 0 25px;
        }

        .faq-items {
          width: 40%;

          .faq-item {
            background: #f8f8f8;
            border-left: 6px solid #FCAF05;
            padding: 17px 30px 17px 50px;
            margin-bottom: 15px;
            cursor: pointer;

            &:last-of-type {
              margin-bottom: 0;
            }

            .faq-answer {
              margin-top: 25px;
              //
              display: none;
            }

            &.active-faq-item {
              .faq-answer {
                display: block;
              }

              .faq-header {
                .faq-name {
                  h2 {
                    color: #FCAF05;
                  }
                }

                svg path {
                  fill: #FCAF05;
                }
              }
            }

            .faq-header {
              display: flex;
              justify-content: space-between;
              align-items: center;

              .faq-name {
                display: flex;
                align-items: center;

                .faq-icon {
                  width: 46px;
                  height: 46px;
                  background: #fff;
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  margin-right: 22px;
                }

                h2 {
                  font-size: 22px;
                  line-height: 35px;
                  margin: 0;
                }
              }
            }
          }
        }

        .faq-img-frame {
          width: 55%;
        }
      }
    }
  }
</style>
